import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatFormFieldAppearance } from '@angular/material/form-field';

@Component({
  selector: 'app-input-textarea',
  templateUrl: './input-textarea.component.html',
  styleUrls: ['./input-textarea.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputTextAreaComponent {
  readonly label: InputSignal<string> = input<string>();
  readonly placeholder: InputSignal<string> = input<string>();
  readonly formControlRef: InputSignal<FormControl> = input<FormControl>();
  readonly required: InputSignal<boolean> = input<boolean>();
  readonly appearance: InputSignal<MatFormFieldAppearance> =
    input<MatFormFieldAppearance>('outline');
  readonly maxLength: InputSignal<number> = input<number>();
}
